/** Measured viewport geometry, in CSS pixels. Oversized rows align at their beginning. */
export function paperScrollTop(scrollTop:number, viewportTop:number, viewportHeight:number, rowTop:number, rowBottom:number, padding=12):number {
  if(rowTop<viewportTop+padding||rowBottom-rowTop>viewportHeight-2*padding)return Math.max(0,scrollTop+rowTop-viewportTop-padding);
  if(rowBottom>viewportTop+viewportHeight-padding)return Math.max(0,scrollTop+rowBottom-viewportTop-viewportHeight+padding);
  return scrollTop;
}
